define('home/views/ActivityFeedView',[
    'underscore',

    'home/views/ActivityCardCollectionView',
    'home/views/common/FetchableCollectionLayout',

    'home/templates/activityFeed',
], function (
    _,

    ActivityCardCollectionView,
    FetchableCollectionLayout,

    activityFeedTemplate
) {
    'use strict';

    /**
      * A view that shows a feed of activity items and a footer that handles pagination.
      */
    var ActivityFeedView = FetchableCollectionLayout.extend({
        template: activityFeedTemplate,

        regions: _.defaults({
            coverRegion: '[data-role=cover-area]',
        }, FetchableCollectionLayout.prototype.regions),

        fetchableCollectionView: ActivityCardCollectionView,

        initialize: function (options) {
            FetchableCollectionLayout.prototype.initialize.apply(this, arguments);

            if (options.coverView)
                this.coverView = options.coverView;
        },

        onDomRefresh: function () {
            /* eslint-disable new-cap */
            FetchableCollectionLayout.prototype.onDomRefresh.apply(this, arguments);

            if (this.coverView) {
                // If the cover view has a class function for selecting the model it expects
                // to receive, use it.
                var coverModel = this.coverView.getModel ?
                    this.coverView.getModel(this.model) :
                    this.model;
                this.coverRegion.show(new this.coverView({ model: coverModel }));
            }
            /* eslint-enable new-cap */
        },

        getMetaAttrs: function () {
            var cover = this.coverRegion.currentView;
            return cover && cover.getMetaAttrs && cover.getMetaAttrs() || '';
        },
    });

    return ActivityFeedView;
});

